import { TransportActiveDocumentDetail } from '../../TransportActiveDocument/detail/TransportActiveDocumentDetail';

export default function SupplierTransportActiveDocumentDetail() {
  return <TransportActiveDocumentDetail isSupplierDdt={true} />;
}
